import React from 'react';

import ArrowLeft from 'assets/images/arrow-left.svg';

import BaseIcon from './BaseIcon';

const ArrowLeftIcon = props => <BaseIcon {...props} src={ArrowLeft} />;

export default ArrowLeftIcon;
